'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styledComponents = require('./styled-components.js');

var TitledHorizontalBar = function (props) {
    var titleText = props.titleText, oneHundredPercent = props.oneHundredPercent, score = props.score, barColor = props.barColor, barHeight = props.barHeight, barBottomOffset = props.barBottomOffset, titleFlex = props.titleFlex, barFlex = props.barFlex, suffix = props.suffix;
    var percentage = Math.round((score * 100) / oneHundredPercent) + "%";
    return (React__default.createElement(styledComponents.Main, null,
        React__default.createElement(styledComponents.Title, { flex: titleFlex }, titleText),
        React__default.createElement(styledComponents.BarContainer, { flex: barFlex },
            React__default.createElement(styledComponents.ProgressBar, { color: barColor, percentage: percentage, height: barHeight, bottom: barBottomOffset }),
            React__default.createElement(styledComponents.Score, null,
                score,
                suffix))));
};

module.exports = TitledHorizontalBar;
